import { createSlice } from "@reduxjs/toolkit";
import { addToCart } from "./cart-slice";

/*
 * Transient UI state. Deliberately kept out of the cart slice so nothing
 * here touches cart data, and blacklisted from redux-persist so a drawer
 * that was open on unload doesn't reopen itself on the next visit.
 */
const uiSlice = createSlice({
  name: "ui",
  initialState: {
    isCartDrawerOpen: false,
  },
  reducers: {
    openCartDrawer(state) {
      state.isCartDrawerOpen = true;
    },
    closeCartDrawer(state) {
      state.isCartDrawerOpen = false;
    },
  },
  extraReducers: (builder) => {
    // Reacting to the cart's own action means every add-to-cart entry point
    // (product card, product page, quick-view modal) slides the drawer open
    // without each one having to remember to dispatch it.
    //
    // Quantity steppers reuse addToCart to bump an existing line, passing the
    // whole cart item back. Those already carry a cartItemId, and a "+" press
    // is not a new add — without this guard, nudging the quantity on the cart
    // page threw the drawer open over it.
    builder.addCase(addToCart, (state, action) => {
      if (action.payload?.cartItemId) return;
      state.isCartDrawerOpen = true;
    });
  },
});

export const { openCartDrawer, closeCartDrawer } = uiSlice.actions;
export default uiSlice.reducer;
